import * as customIcons from './custom-icons';
import * as muiIcons from './mui-icons';
const icons = { ...customIcons, ...muiIcons };
export * from './mui-icons';
export * from './custom-icons';
export default icons;
export function getIcon(icon) {
    return icons[icon];
}
